/**
 *
 * DialogSectionTitle
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import {
  SIZES,
  StyledSectionSubtitle,
  StyledSectionTitle,
} from './DialogSectionTitle.styles';

const DialogSectionTitle = ({ size, title, subtitle, ...props }) => (
  <StyledSectionTitle $size={size} {...props}>
    {title}
    {subtitle && <StyledSectionSubtitle>{subtitle}</StyledSectionSubtitle>}
  </StyledSectionTitle>
);

DialogSectionTitle.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default memo(DialogSectionTitle);
